import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alw-overlay"
}
const _hoisted_2 = {
  class: "alw-box",
  role: "alertdialog",
  "aria-live": "assertive",
  "aria-label": "Aviso de inatividade"
}
const _hoisted_3 = { class: "alw-countdown" }
const _hoisted_4 = { class: "alw-desc" }

import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { showWarning, secondsLeft, continueSession, performLogout } from '@/composables/useAutoLogout'


export default /*@__PURE__*/_defineComponent({
  __name: 'AutoLogoutWarningModal',
  setup(__props) {

const store  = useStore()
const router = useRouter()

function handleContinueSession() {
  continueSession(store)
}

function handleLogoutNow() {
  performLogout(store, router)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "alw-fade" }, {
      default: _withCtx(() => [
        (_unref(showWarning))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(secondsLeft)), 1),
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "alw-title" }, "Você ainda está aí?", -1)),
                _createElementVNode("div", _hoisted_4, [
                  _cache[0] || (_cache[0] = _createTextVNode(" Por inatividade, você será desconectado automaticamente em ", -1)),
                  _createElementVNode("strong", null, _toDisplayString(_unref(secondsLeft)) + "s", 1),
                  _cache[1] || (_cache[1] = _createTextVNode(". ", -1))
                ]),
                _createElementVNode("div", { class: "alw-actions" }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "alw-btn alw-btn--primary",
                    onClick: handleContinueSession
                  }, " Continuar logado "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "alw-btn alw-btn--muted",
                    onClick: handleLogoutNow
                  }, " Deslogar agora ")
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})